import { palette } from 'app_previous/styles/colors';
import { layout } from 'app_previous/styles/layout';
import styled from 'styled-components';

export const ResourceBottomCallToActionContainer = styled.div`
  max-width: 1000px;
  box-sizing: border-box;
  padding: 0 1.5rem;
  margin: 5rem auto 3.75rem;
`;

export const ResourceBottomCallToActionContent = styled.div`
  width: 100%;
  border-radius: 16px;
  background: ${palette.newGreen};
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 2.5rem;
  overflow: hidden;

  @media screen and (max-width: ${layout.md}) {
    grid-template-columns: 1fr;
    padding: 2rem;
    box-sizing: border-box;
  }
`;

export const TextBlock = styled.section`
  display: grid;
  grid-row-gap: 1rem;
  justify-self: end;
  align-self: center;
  max-width: 380px;

  .link-branded {
    width: fit-content;
    border-color: ${palette.greyText};
  }

  @media screen and (max-width: ${layout.md}) {
    justify-self: center;
    align-self: center;
    max-width: 100%;
    > a {
      justify-self: center;
    }
    .link-branded {
      width: 100%;
      max-width: 340px;
      margin: 0 auto;
    }

    .ready-to-start-building-headline {
      text-align: center;
    }
  }
`;

export const Caption = styled.span`
  font-size: 0.75rem;
  color: ${palette.white};

  @media screen and (max-width: ${layout.md}) {
    margin: 0 auto;
  }
`;

export const ImageBlock = styled.div`
  max-width: 100%;
  object-fit: cover;
  height: 100%;

  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: ${layout.md}) {
    display: none;
  }
`;
